export default __webpack_public_path__ + "static/media/send.89f6a281.svg";